module.exports = __webpack_public_path__ + "src/assets/img/cmd-go-ahj-stop.78ec63bb.svg";